(function() {

    var filters = document.querySelectorAll('.approved-products-toggle__input');

    if (!filters.length) {

        return;

    }

    var url = new URL(window.location.href);
    var isApproved = url.searchParams.get('approved_products') === '1';

    filters.forEach(function(filter) {

        filter.checked = isApproved;

        filter.addEventListener('change', function() {

            var isChecked = this.checked;
            var newUrl = new URL(window.location.href);

            filters.forEach(function(item) {

                item.checked = isChecked;

            });

            if (isChecked) {

                newUrl.searchParams.set('approved_products', '1');

            } else {

                newUrl.searchParams.delete('approved_products');

            }

            window.location.href = newUrl.toString();

        });

    });

})();